import React from 'react'
import { storiesOf } from '@storybook/react'
import withReadme from 'storybook-readme/with-readme'

// Digital-Commons Theming
import { ThemeProvider } from 'styled-components'
import { getBaseTheme } from '../..'

// Component to surface in storybook
import Typeahead from '.'
import data from './demos/sample.json'
import dataDropdown from './demos/sampleDropdown.json'
import dataMultiHeaderDropdown from './demos/multiHeaderDropdown.json'
import readme from './readme.md'

// Story Setup
const stories = storiesOf('Digital-Commons/Typeahead', module)

stories.addDecorator(withReadme(readme))

// Theming setup
const mode = 'refinitiv'
const baseTheme = getBaseTheme({ mode })
const builtTheme = {
  mode,
  ...baseTheme
}

// Stories
stories
  .add('Default', () => (
    <div style={{margin: '70px auto', width: '50%'}}>
      <ThemeProvider theme={builtTheme}>
        <Typeahead {...data} />
      </ThemeProvider>
      <div style={{padding: '50px 0', color: '#ccc'}}>
        Here is some text just to show the dropdown breaking out. Also, did you know that, contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.
      </div>
    </div>
  ))
  .add('Dropdown', () => (
    <ThemeProvider theme={builtTheme}>
      <Typeahead {...dataDropdown} />
    </ThemeProvider>
  ))
  .add('MultiHeaderDropdown', () => (
    <ThemeProvider theme={builtTheme}>
      <Typeahead {...dataMultiHeaderDropdown} />
    </ThemeProvider>
  ))
